import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";

const Div = (props) => <div {...props}></div>;

const RoutesBuilder = ({ routes = [] }) => {
  return (
    <Suspense fallback={<div />}>
      <Routes>
        {routes.map((route, i) => {
          const Guard = route.guard || Div;
          const Layout = route.layout || Div;
          const Component = route.component;

          return (
            <Route
              key={i}
              path={route.path}
              exact={route.exact}
              element={((props) => {
                return (
                  <Guard>
                    <Layout {...props} {...route.props}>
                      {route.routes ? (
                        <RoutesBuilder routes={route.routes} />
                      ) : (
                        <Component {...props} {...route.props} />
                      )}
                    </Layout>
                  </Guard>
                );
              })()}
            />
          );
        })}
      </Routes>
    </Suspense>
  );
};

export default RoutesBuilder;
